    export class AbilityModel  {
        name: string = "";
        selected: number = 0;
    }


    export class RolesModel  {
      key: string = "";
      name: string = "";
      abilities: {} = {};
      storage: {} = {};

  constructor(data = null) {
      if(data && data?.key) {
          this.key = data.key;
      }
      if(data && data?.name) {
          this.name = data.name;
      }
      if(data && data?.storage) {
          this.storage = data.storage;
      }
      
  } 
  
  setAbilities=(data, selected = null)      => {
      Object.keys(data).map((item) => {
          this.abilities[item] = {}
              let ability = new AbilityModel();
              ability.name = item+".*";
                if(selected && selected[item] && selected[item]["*"]) {
                    ability.selected = 1;      
                }
              
              this.abilities[item]["*"] = ability;
          Object.keys(data[item]).map((item2) => {
              let ability = new AbilityModel();
              ability.name = item+"."+item2;
                if(selected && selected[item] && selected[item][item2]) {
                    ability.selected = 1;      
                }
              
              this.abilities[item][item2] = ability;
              });
          });
  }
}